import {
  IconActivity,
  IconGraph,
  IconHome,
  IconPresentation,
  IconRocket,
  IconSettings,
  IconUsersGroup,
} from "@tabler/icons-react";
import { Permission } from "@/services/permissions";
import { MAIN_AGENCY_ID, isMetaReviewEmail, canViewStatusPage } from "@/lib/constants";

interface UserPermissions {
  hasPermission: (permission: Permission) => boolean;
  hasAnyPermission: (permissions: Permission[]) => boolean;
  canImpersonate: boolean;
  canManageUsers: boolean;
  canViewCampaigns: boolean;
  agencyId?: string;
  email?: string;
}

export const sidebarLinks = (user: UserPermissions) => [
  {
    page: "dashboard",
    href: "/",
    title: "Home",
    hero: <IconHome className="icon-dark" />,
  },
  user.canViewCampaigns && {
    page: "campaign",
    href: "/campaign",
    title: "Campaigns",
    hero: <IconGraph className="icon-dark" />,
  },
  user.agencyId === MAIN_AGENCY_ID &&
    !isMetaReviewEmail(user.email) &&
    user.hasPermission(Permission.CAMPAIGN_VIEW) && {
      page: "social-requests",
      href: "/social-requests",
      title: "X Trending",
      hero: <IconRocket className="icon-dark" />,
    },
  user.canImpersonate && {
    page: "pitch-builder",
    href: "/pitch-builder",
    title: "Pitch Builder",
    hero: <IconPresentation className="icon-dark" />,
  },
  user.hasAnyPermission([
    Permission.USER_MANAGE,
    Permission.CAMPAIGN_CREATE,
    Permission.CAMPAIGN_EDIT,
  ]) && {
    page: "people",
    href: "/people",
    title: "People",
    hero: <IconUsersGroup className="icon-dark" />,
  },
  canViewStatusPage(user.agencyId) && {
    page: "status",
    href: "/status",
    title: "Status",
    hero: <IconActivity className="icon-dark" />,
  },
  {
    page: "settings",
    href: "/me",
    title: "Settings",
    hero: <IconSettings className="icon-dark" />,
  },
  // checkRoles(["agency-admin", "agency-user", "superadmin"]) && {
  //   page: "artist",
  //   href: "/artist",
  //   title: "Artists",
  //   hero: <IconMusic className="icon-dark" />,
  // },
  // checkRoles(["agency-admin", "superadmin"]) && {
  //   page: "users",
  //   href: "/users",
  //   title: "Users",
  //   hero: <IconUsersGroup className="icon-dark"/>,
  // },
  // checkRoles(["agency-admin", "agency-user", "superadmin"]) && {
  //   page: "creator",
  //   href: "/creators",
  //   title: "Creators",
  //   hero: <IconHash className="icon-dark"/>,
  // },
  // checkRoles(["superadmin"]) && {
  //   page: "agency",
  //   href: "/agencies",
  //   title: "Agencies",
  //   hero: <IconBuilding className="icon-dark"/>,
  // },
  // checkRoles(["superadmin"]) && {
  //   page: "scraper-accounts",
  //   href: "/admin/scraping/accounts",
  //   title: "Scrapers",
  //   hero: <IconTool className="icon-dark"/>,
  // },
];
